// A plan laid on the satellite map by its corners (Site Walks list #16, #18):
// Leaflet's own image overlay only lies square to north, and a site plan is
// turned however the site is. This one takes the picture's corners on the
// ground ([[lat, lon] top-left, top-right, bottom-right, bottom-left]) and
// sets a CSS matrix on the <img> so it lands on them, following pans and
// zooms (zoom animation included).
//
//   const plan = rotatedImage(L, url, corners, { width, height, opacity, pane }).addTo(map)
//   plan.setCorners(corners) / plan.setOpacity(0.5) / plan.remove()
import { cornerMatrix } from "./plan_geometry"

export function rotatedImage(L, url, corners, { width, height, opacity = 0.7, pane = "overlayPane" } = {}) {
  const Layer = L.Layer.extend({
    options: { pane },

    onAdd(map) {
      const img = L.DomUtil.create("img", "leaflet-zoom-animated")
      img.src = url
      img.alt = ""
      img.draggable = false
      Object.assign(img.style, {
        position: "absolute", left: "0", top: "0", width: `${width}px`, height: `${height}px`,
        transformOrigin: "0 0", pointerEvents: "none", userSelect: "none", maxWidth: "none", opacity: String(opacity)
      })
      this._img = img
      this.getPane().appendChild(img)
      map.on("zoom viewreset move", this._reset, this)
      if (map._zoomAnimated) map.on("zoomanim", this._animateZoom, this)
      this._reset()
    },

    onRemove(map) {
      map.off("zoom viewreset move", this._reset, this)
      map.off("zoomanim", this._animateZoom, this)
      this._img?.remove()
      this._img = null
    },

    setCorners(next) {
      corners = next
      this._reset()
      return this
    },

    setOpacity(value) {
      opacity = value
      if (this._img) this._img.style.opacity = String(value)
      return this
    },

    _reset() {
      if (!this._map || !this._img || !corners) return
      const at = (c) => this._map.latLngToLayerPoint(L.latLng(c[0], c[1]))
      this._place(at(corners[0]), at(corners[1]), at(corners[3]))
    },

    _animateZoom(e) {
      if (!this._img || !corners) return
      const at = (c) => this._map._latLngToNewLayerPoint(L.latLng(c[0], c[1]), e.zoom, e.center)
      this._place(at(corners[0]), at(corners[1]), at(corners[3]))
    },

    _place(topLeft, topRight, bottomLeft) {
      const m = cornerMatrix(topLeft, topRight, bottomLeft, width, height)
      this._img.style.transform = `matrix(${m.map((v) => v.toFixed(6)).join(",")})`
    }
  })
  return new Layer()
}
